/**
 * CAION Flutter 앱 WebView 브리지
 * - 앱 셸이 window.CaionApp 을 주입함
 */
export type CaionNativePayload =
  | { type: 'login' | 'auth' | 'registerPush'; token: string; user?: unknown }
  | { type: 'logout' }
  | { type: 'navigate'; path: string }

declare global {
  interface Window {
    CaionApp?: {
      isNative?: boolean
      version?: string
      postMessage: (payload: CaionNativePayload | string) => void
    }
    __caionBridgeReady?: boolean
  }
}

export const isCaionNativeApp = (): boolean => {
  return !!(window.CaionApp && window.CaionApp.isNative)
}

export const notifyNative = (payload: CaionNativePayload): void => {
  try {
    if (window.CaionApp?.postMessage) {
      window.CaionApp.postMessage(payload)
      return
    }
    // 앱 주입 전: ready 이벤트 대기 후 1회 재시도
    const handler = () => {
      window.removeEventListener('caion-app-ready', handler)
      try {
        window.CaionApp?.postMessage(payload)
      } catch {
        /* ignore */
      }
    }
    window.addEventListener('caion-app-ready', handler, { once: true })
  } catch {
    /* ignore */
  }
}

export const notifyNativeLogin = (token: string, user?: unknown): void => {
  if (!token) return
  notifyNative({ type: 'login', token, user })
}

export const notifyNativeLogout = (): void => {
  notifyNative({ type: 'logout' })
}
